<template>
    <div class="printfieldWrapper">
        <div style="text-align: center; padding: 1px 0px; border-bottom: 1px solid rgb(173, 180, 187); box-shadow: rgb(243, 253, 255) 0px 1px 0px;"> <!--border-bottom: 1px solid rgb(9, 12, 15); box-shadow: rgb(80, 94, 101) 0px 1px 0px;-->
            <label style="padding-top: 8px; text-align: center;">{{$Jed.firstUpperTranslate('advanced printing')}}</label>
        </div>
        <ul class="nav nav-pills f-s">
            <li v-if="activeData" class="active" style="float: none; width: 100%; padding: 5px 16px 0px 16px;"><a class="f-s-a" href="#">{{activeData.father.des}}</a></li>
        </ul>
        
        <div class="well" style="margin: 15px; padding: 5px 19px 15px 19px;">
            <form class="search-form row">
                <div style="box-shadow: rgb(80, 94, 101) 0px 1px 0px;">
                    <label style="padding-top: 8px;">{{$Jed.firstUpperTranslate('include')}}</label>
                </div>     
                <input-w :key="prop" v-for="(value, prop) in includes" v-if="visible[prop]" v-model="includes[prop]" :configs='{"id": prop+"Check"}'>
                    <input  :disabled="(prop == 'discendenti' && disableTree) || (prop == 'discendenti' && noNephews) || (prop == 'indice' && noNephews)" :id="prop" type="checkbox" v-model="includes[prop]" style="float: right;">
                    <label class="reduce" :for="prop">{{labels[prop]}}</label>
                </input-w> 
            </form>

            <form v-if="optionsList.length>0" class="search-form row">
                <div style="box-shadow: rgb(80, 94, 101) 0px 1px 0px;">
                    <label style="padding-top: 8px;">{{$Jed.firstUpperTranslate('printing options')}}</label>
                </div>     
                <input-w :key="prop" v-for="(value, prop) in options" v-if="visible[prop]" v-model="options[prop]" :configs='{"id": prop+"Check"}'>
                    <input :disabled="prop == 'fr' && noNephews" :id="prop" type="checkbox" v-model="options[prop]" style="float: right;">
                    <label class="reduce" :for="prop">{{labels[prop]}}</label>
                </input-w> 
            </form>
        </div>
        <div id="capPrint" style="text-align: center">
            <dynButton :configs="{ID: 'buttons.print', visible: true}" :icon="$root.icons.print" btnClasses="btn-primary"
                :exec="sendPrintRequest"
                :styleObj="{'z-index': '999', 'width': '50%', 'height': '26px'}">
            </dynButton>
        </div>          
        <div v-if="showWarning" class="panel panel-warning" style="margin: 12px; text-align: center;">
            <div class="panel-heading">{{translateWarning(warning)}}
                <div v-if="showAvailables" style="padding-top: 5px;">{{printableList.join(', ')}}</div>
            </div>
        </div>  

    </div>
</template>

<script>
    import InputW from '../dynamic/inputWrapper/inputWrapper.vue'
    import dynButton from "../dynamic/DynButton.vue";

    export default {
        
        props: {
            activeData: {
                type: Object,
                default: null
            }
        },
        components: {
            InputW,
            dynButton
        },
        mounted: function(){
            var vm = this;
            this.printableList = []
            var productTypesColl = vm.$root.dbRegistry.getCollection('productTypes');
        
            var cur_lang = vm.$root.token.siglaLingua;
            for(var prop in vm.$Behaviors.printable){
                
                var record = productTypesColl.find({
                    'iid': prop
                })
                var des = prop;
                if(record && record[0]){
                    record = record[0];
                    des =  record.des[cur_lang] ? record.des[cur_lang] : record.id
                }
                
                this.printableList.push(des)

                /* //se sono definiti dei permessi di stampa sul profilo dell'utente
                //essi prevalgono sui tipi definiti nel behaviour printable
                if(vm.$Components["printableTypes"]){
                    if(vm.$Components["printableTypes"].hasOwnProperty(prop)){
                        //quindi nella lista ci metto solo i tipi definiti per il profilo
                        this.printableList.push(des)
                    }
                }else{
                    //se invece non sono definiti dei permessi sul profilo, metto tutti i tipi definiti nel behaviour printable
                    this.printableList.push(des)
                } */
            }
            vm.showAvailables = false;
            this.$nextTick(()=>{
                if(!vm.$Behaviors.printable.hasOwnProperty(vm.activeData.father.iti)){ //se il tipo del nodo attuale non è tra quelli stampabili, disabilito il button
                    document.getElementById("capPrint").firstChild.disabled = true;
                    document.getElementById("capPrint").firstChild.style.cursor = 'not-allowed'
                    vm.showWarning = true;
                   
                    if(vm.printableList.length > 0){
                        vm.warning = "print unavailable for this element. Print available only for the following products:";
                        vm.showAvailables = true;
                    } else {
                        vm.warning = "print unavailable for any products";
                    }
                    
                }else{ //se è stampabile, ma ci sono ulteriori condizioni
                    if(vm.$Components["disableDescendants"]){ //se da profilo sono disabilitati i discendenti, non faccio il controllo che sia stampabile "solo con discendenti"
                        vm.disableTree = true;
                        vm.showWarning = false;
                    }else{
                        if(vm.$Behaviors.printable[vm.activeData.father.iti] == 'onlyWithDescendants'){ //deve essere spuntato il flag discendenti
                            if(!this.includes['discendenti']){ //se il flag discendenti non è spuntato, lo spunto
                                /*
                                document.getElementById("capPrint").firstChild.disabled = true;
                                document.getElementById("capPrint").firstChild.style.cursor = 'not-allowed'
                                vm.showWarning = true;
                                vm.warning =  this node is printable only with descendants";
                                */
                                document.getElementById("capPrint").firstChild.disabled = false;
                                vm.includes.discendenti = true;
                                document.getElementById("capPrint").firstChild.style.cursor = 'pointer'
                            }
                        }
                    }
                    /* if(vm.$Components["printableTypes"] && !vm.$Components["printableTypes"].hasOwnProperty(vm.activeData.father.iti)){ //se il profilo dell'utente corrente non permette la stampa del nodo attuale
                        document.getElementById("capPrint").firstChild.disabled = true;
                        document.getElementById("capPrint").firstChild.style.cursor = 'not-allowed'
                        vm.includes.discendenti = false;
                        vm.showWarning = true;
                        if(vm.printableList.length > 0){
                            vm.warning = "print unavailable for this element. Print available only for the following products:";
                            vm.showAvailables = true;
                        } else {
                            vm.warning = "print unavailable for any products";
                        }
                    } */
                }
            })

            

            this.checkSelectedType();
            try {  
                var def = this.$root.supportDefaults.Stampa;
                this.$root.sup_apply(null, null, null, def);
            } catch(err){}
            var conf = this.$Components["support.print"];
            if(conf){
                if(conf.includes){
                    for(var prop in conf.includes){
                        this.visible[prop] = conf.includes[prop];
                        if(!conf.includes[prop]){
                            this.includes[prop] = false;
                        }
                    }
                }
                if(conf.options){
                    for(var prop in conf.options){
                        this.visible[prop] = conf.options[prop];
                        if(!conf.options[prop]){
                            this.options[prop] = false;
                        }else{
                            this.optionsList.push(prop)
                        }
                    }
                }
            }
            for(var c in this.activeData.children){
                if(!this.activeData.children[c].cco){
                    this.noNephews = true
                    $('#discendenti').prop('checked', false);
                    $('#indice').prop('checked', false);
                    this.includes.discendenti = false;
                    this.includes.indice = false;
                }else{
                    this.noNephews = false
                    break; //se almeno un figlio ha la proprietà cco allora il flag discendenti può rimanere abilitato
                }
            }
        },
        data: function(){
            var vm = this;
            return {
                visible: {
                    disegno: true,
                    distinta: true,
                    discendenti: true,
                    indice: true,
                    specifiche: true, //datitecnici
                    fr: true
                },
                includes: {
                    disegno: true,
                    distinta: true,
                    discendenti: false,
                    indice: false,
                    specifiche: false //datitecnici
                },
                disableTree: false,
                options: {
                    fr: false
                },
                optionsList: [],
                labels: {
                    disegno: vm.$Jed.firstUpperTranslate('image'),
                    distinta: vm.$Jed.firstUpperTranslate('list'),
                    discendenti: vm.$Jed.firstUpperTranslate('descendants'),
                    indice: vm.$Jed.firstUpperTranslate('table of contents'),
                    specifiche: vm.$Jed.firstUpperTranslate('tech data'),
                    fr: vm.$Jed.firstUpperTranslate('double-sided')
                },
                noNephews: false,
                showWarning: false,
                warning: null,
                showAvailables: false,
                printableList: []
            }
        },
        watch: {
            activeData: function(){
                if(this.activeData != null){
                    this.checkSelectedType();
                }
                for(var c in this.activeData.children){
                    if(!this.activeData.children[c].cco){
                        this.noNephews = true
                        $('#discendenti').prop('checked', false);
                        $('#indice').prop('checked', false);
                        this.includes.discendenti = false;
                        this.includes.indice = false;
                    }else{
                        this.noNephews = false
                        break;
                    }
                }
                //quando cambia activedata resetto tutte le opzioni di stampa, tra cui il fronte/retro
                $('#fr').prop('checked', false);
                this.options.fr = false;
            },
            disableTree: function(){
                if(this.disableTree){
                    this.includes.discendenti = false;
                }
            },
            includes: {
                handler: function () { 
                    if(this.includes.discendenti){
                        document.getElementById("capPrint").firstChild.disabled = false;
                        document.getElementById("capPrint").firstChild.style.cursor = 'pointer'
                        this.showWarning = false;
                        
                    }else if(this.$Behaviors.printable[this.activeData.father.iti] == 'onlyWithDescendants'){
                        document.getElementById("capPrint").firstChild.disabled = true;
                        document.getElementById("capPrint").firstChild.style.cursor = 'not-allowed'
                        this.showWarning = true;
                        this.warning = "this node is printable only with descendants";
                    }
                    
                    /* //se il profilo dell'utente corrente non permette la stampa del nodo attuale
                    if(this.$Components["printableTypes"] && !this.$Components["printableTypes"].hasOwnProperty(this.activeData.father.iti)){ 
                        document.getElementById("capPrint").firstChild.disabled = true;
                        document.getElementById("capPrint").firstChild.style.cursor = 'not-allowed'
                        this.showWarning = true;
                        if(this.printableList.length > 0){
                            this.warning = "print unavailable for this element. Print available only for the following products:";
                            this.showAvailables = true;
                        } else {
                            this.warning = "print unavailable for any products";
                        }
                    } */
                },
                deep: true
            }
        },
        methods: {
            translateWarning(){
                var msg = this.warning
                try {
                    msg = this.$Jed.firstUpperTranslate(this.warning);
                } catch(err){}
               
                return msg;
            },
            sendPrintRequest: function(){
                this.$root.print(this.includes, this.options);
            },
            checkSelectedType: function(){
                try {
                    if(this.$root.front_end_configs.allowCategoriesPrint == false){
                        var productTypesColl = this.$root.dbRegistry.getCollection('productTypes');
                        var id = this.activeData.father.typ;
                        var dec = productTypesColl.find({
                            "id": id
                        })
                        dec = dec && dec.length > 0 ? dec[0] : null;
                        if(dec && dec.iid == "category"){
                            this.disableTree = true;
                        } else {
                            this.disableTree = false;
                        }
                    } else {
                        this.disableTree = false;
                    }
                } catch(err) {
                    console.log("Error on Print Configs: ", err);
                    this.disableTree = false;
                }
            }
        }
    }
</script>
<style scoped>
ul.nav.nav-pills a {
  border-style: none;
  color: #b8c7ce;
  padding: 5px 10px;
  font-weight: 400;
  border-radius: 2px;
}

ul.f-s {
  padding-top: 0px;
  width: 100%;
}

ul.f-s > li {
  margin-left: 0px;
}

a.f-s-a {
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-x: hidden;
}

.search-form {
    margin: 0px;
}

.search-form > div {
    margin-bottom: 6px;
}

label.reduce {
    font-weight: 400 !important;
}
</style>
<style>
#capPrint i {
    font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// src/components/menu-sup-components/Stampa.vue?d90b1bf4